"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@mui/styles");
var _CircularProgress = _interopRequireDefault(require("@mui/material/CircularProgress/CircularProgress.js"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _styles.makeStyles)(() => ({
  root: {
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 999999,
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(189, 189, 189, .5)'
  }
}));
var _default = () => {
  const classes = useStyles();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: classes.root,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CircularProgress.default, {
      color: "primary"
    })
  });
};
exports.default = _default;